module.exports = __webpack_public_path__ + "img/defalut_boy.0ae45e20.png";